<template>
  <button :class="['atom-button', `atom-button--${variant}`, `atom-button--${size}`, { 'atom-button--disabled': disabled }]" :disabled="disabled" @click="handleClick">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: "AtomButton",
    props: {
      variant: {
        type: String,
        default: "primary",
        validator: (value) => ["primary", "secondary", "danger", "success"].includes(value),
      },
      size: {
        type: String,
        default: "medium",
        validator: (value) => ["small", "medium", "large"].includes(value),
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClick(event) {
        if (!this.disabled) {
          this.$emit("click", event);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .atom-button {
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-family: $newFont_medium;
    font-weight: 500;
    transition: all 0.2s;
    outline: none;

    &--small {
      padding: 6px 12px;
      font-size: 12px;
    }

    &--medium {
      padding: 6px 12px;
      font-size: 16px;
    }

    &--large {
      padding: 14px 28px;
      font-size: 16px;
    }

    &--primary {
      background: $primary-color;
      color: white;

      &:hover:not(.atom-button--disabled) {
        background: #a12727;
      }
    }

    &--secondary {
      background: #ffffff;
      color: $primary-color;
      font-size: 16px;
      font-weight: 500;
      border: 1px solid #bd0909;
      font-family: $newFont_medium;
      transition: all 0.2s ease-in-out;

      &:hover:not(.atom-button--disabled) {
        background: #bd090915;
        color: #bd0909;
      }
    }

    &--danger {
      background: $primary-color;
      color: white;

      &:hover:not(.atom-button--disabled) {
        background: $primary-color;
      }
    }

    &--success {
      background: #28a745;
      color: white;

      &:hover:not(.atom-button--disabled) {
        background: #218838;
      }
    }

    &--disabled {
      background: #adb5bd;
      cursor: not-allowed;
      color: white;
    }
  }
</style>
